"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASSET_TYPE_LABELS = exports.ASSET_TYPE_LABEL_ENTRIES = exports.DATA_QUALITY_LABELS = exports.PROCESS_TYPE_LABELS = exports.PROCESS_TYPE_LABEL_ENTRIES = exports.GAS_TYPE_LABELS = exports.GAS_TYPE_LABEL_ENTRIES = exports.FUGITIVE_GAS_TYPE_LABELS = exports.FUGITIVE_GAS_TYPE_LABEL_ENTRIES = exports.REFRIGERANT_TYPE_LABELS = exports.REFRIGERANT_TYPE_LABEL_ENTRIES = exports.VEHICLE_TYPE_LABELS = exports.VEHICLE_TYPE_LABEL_ENTRIES = exports.FUEL_TYPE_LABELS = exports.FUEL_TYPE_LABEL_ENTRIES = exports.UNIT_LABELS = exports.UNIT_LABEL_ENTRIES = void 0;
const enums_1 = require("./enums");
/** Flattens a LabelEntry record into simple string labels (e.g. 'CNG (Compressed Natural Gas)') */
const toStringLabels = (entries) => Object.fromEntries(Object.entries(entries).map(([k, { label, description }]) => [
    k,
    description ? `${label} (${description})` : label,
]));
// ---------------------------------------------------------------------------
// Units
// ---------------------------------------------------------------------------
exports.UNIT_LABEL_ENTRIES = {
    [enums_1.ActivityUnit.Litres]: { label: 'Liters' },
    [enums_1.ActivityUnit.Gallons]: { label: 'Gallons' },
    [enums_1.ActivityUnit.Kilograms]: { label: 'Kilograms' },
    [enums_1.ActivityUnit.Tonnes]: { label: 'Tonnes' },
    [enums_1.ActivityUnit.Pounds]: { label: 'Pounds' },
    [enums_1.ActivityUnit.ShortTons]: { label: 'Short Tons' },
    [enums_1.ActivityUnit.KWh]: { label: 'kWh' },
    [enums_1.ActivityUnit.MWh]: { label: 'MWh' },
    [enums_1.ActivityUnit.GJ]: { label: 'Gigajoules' },
    [enums_1.ActivityUnit.MJ]: { label: 'Megajoules' },
    [enums_1.ActivityUnit.Therms]: { label: 'Therms' },
    [enums_1.ActivityUnit.MMBTU]: { label: 'MMBtu' },
    [enums_1.ActivityUnit.CubicMeters]: { label: 'Cubic Meters', description: 'm³' },
    [enums_1.ActivityUnit.CubicFeet]: { label: 'Cubic Feet' },
    [enums_1.ActivityUnit.Kilometers]: { label: 'Kilometers' },
    [enums_1.ActivityUnit.Miles]: { label: 'Miles' },
    [enums_1.ActivityUnit.SquareMeters]: { label: 'Square Meters' },
    [enums_1.ActivityUnit.SquareFeet]: { label: 'Square Feet' },
    [enums_1.ActivityUnit.Each]: { label: 'Each' },
};
exports.UNIT_LABELS = toStringLabels(exports.UNIT_LABEL_ENTRIES);
// ---------------------------------------------------------------------------
// Fuel types
// ---------------------------------------------------------------------------
exports.FUEL_TYPE_LABEL_ENTRIES = {
    [enums_1.FuelType.NaturalGas]: { label: 'Natural Gas' },
    [enums_1.FuelType.LPG]: { label: 'LPG', description: 'Liquefied Petroleum Gas' },
    [enums_1.FuelType.Propane]: { label: 'Propane' },
    [enums_1.FuelType.Butane]: { label: 'Butane' },
    [enums_1.FuelType.CNG]: { label: 'CNG', description: 'Compressed Natural Gas' },
    [enums_1.FuelType.LNG]: { label: 'LNG', description: 'Liquefied Natural Gas' },
    [enums_1.FuelType.Hydrogen]: { label: 'Hydrogen' },
    [enums_1.FuelType.Diesel]: { label: 'Diesel' },
    [enums_1.FuelType.Petrol]: { label: 'Petrol', description: 'Gasoline' },
    [enums_1.FuelType.Biodiesel]: { label: 'Biodiesel' },
    [enums_1.FuelType.HeavyFuelOil]: { label: 'Heavy Fuel Oil' },
    [enums_1.FuelType.LightFuelOil]: { label: 'Light Fuel Oil' },
    [enums_1.FuelType.Kerosene]: { label: 'Kerosene' },
    [enums_1.FuelType.JetFuel]: { label: 'Jet Fuel' },
    [enums_1.FuelType.Ethanol]: { label: 'Ethanol' },
    [enums_1.FuelType.HVO]: { label: 'HVO', description: 'Hydrotreated Vegetable Oil' },
    [enums_1.FuelType.Coal]: { label: 'Coal', description: 'unspecified' },
    [enums_1.FuelType.CoalIndustrial]: { label: 'Coal', description: 'industrial' },
    [enums_1.FuelType.CoalDomestic]: { label: 'Coal', description: 'domestic' },
    [enums_1.FuelType.Anthracite]: { label: 'Anthracite' },
    [enums_1.FuelType.Coke]: { label: 'Coke' },
    [enums_1.FuelType.Wood]: { label: 'Wood', description: 'unspecified' },
    [enums_1.FuelType.WoodLogs]: { label: 'Wood Logs' },
    [enums_1.FuelType.WoodChips]: { label: 'Wood Chips' },
    [enums_1.FuelType.WoodPellets]: { label: 'Wood Pellets' },
    [enums_1.FuelType.Biomass]: { label: 'Biomass' },
    [enums_1.FuelType.Electric]: { label: 'Electric', description: 'BEV' },
    [enums_1.FuelType.PlugInHybrid]: { label: 'Plug-in Hybrid', description: 'PHEV' },
    [enums_1.FuelType.Hybrid]: { label: 'Hybrid', description: 'HEV' },
    [enums_1.FuelType.Unknown]: { label: 'Unknown' },
};
exports.FUEL_TYPE_LABELS = toStringLabels(exports.FUEL_TYPE_LABEL_ENTRIES);
// ---------------------------------------------------------------------------
// Vehicle types
// ---------------------------------------------------------------------------
exports.VEHICLE_TYPE_LABEL_ENTRIES = {
    [enums_1.VehicleType.Car]: { label: 'Car' },
    [enums_1.VehicleType.SmallCar]: { label: 'Small Car' },
    [enums_1.VehicleType.MediumCar]: { label: 'Medium Car' },
    [enums_1.VehicleType.LargeCar]: { label: 'Large Car' },
    [enums_1.VehicleType.Van]: { label: 'Van' },
    [enums_1.VehicleType.HGV]: { label: 'HGV', description: 'Heavy Goods Vehicle' },
    [enums_1.VehicleType.Motorcycle]: { label: 'Motorcycle' },
};
exports.VEHICLE_TYPE_LABELS = toStringLabels(exports.VEHICLE_TYPE_LABEL_ENTRIES);
// ---------------------------------------------------------------------------
// Refrigerant types
// ---------------------------------------------------------------------------
exports.REFRIGERANT_TYPE_LABEL_ENTRIES = {
    [enums_1.RefrigerantGasType.R134A]: { label: 'R134A' },
    [enums_1.RefrigerantGasType.R410A]: { label: 'R410A' },
    [enums_1.RefrigerantGasType.R404A]: { label: 'R404A' },
    [enums_1.RefrigerantGasType.R407C]: { label: 'R407C' },
    [enums_1.RefrigerantGasType.R507A]: { label: 'R507A' },
    [enums_1.RefrigerantGasType.R422D]: { label: 'R422D' },
    [enums_1.RefrigerantGasType.R32]: { label: 'R32' },
    [enums_1.RefrigerantGasType.R1234yf]: { label: 'R1234yf' },
    // [RefrigerantGasType.R1234ze]: { label: 'R1234ze' },
    [enums_1.RefrigerantGasType.R290]: { label: 'R290', description: 'Propane' },
    [enums_1.RefrigerantGasType.R600A]: { label: 'R600A', description: 'Isobutane' },
    [enums_1.RefrigerantGasType.R744]: { label: 'R744', description: 'CO₂' },
    [enums_1.RefrigerantGasType.R717]: { label: 'R717', description: 'Ammonia' },
    [enums_1.RefrigerantGasType.R22]: { label: 'R22' },
    [enums_1.RefrigerantGasType.R12]: { label: 'R12' },
};
exports.REFRIGERANT_TYPE_LABELS = toStringLabels(exports.REFRIGERANT_TYPE_LABEL_ENTRIES);
// ---------------------------------------------------------------------------
// Fugitive gas types
// ---------------------------------------------------------------------------
exports.FUGITIVE_GAS_TYPE_LABEL_ENTRIES = {
    [enums_1.FugitiveGasType.SF6]: { label: 'SF6', description: 'Sulphur Hexafluoride' },
    [enums_1.FugitiveGasType.NF3]: { label: 'NF3', description: 'Nitrogen Trifluoride' },
    [enums_1.FugitiveGasType.CF4]: { label: 'CF4', description: 'Tetrafluoromethane' },
    [enums_1.FugitiveGasType.C2F6]: { label: 'C2F6', description: 'Hexafluoroethane' },
    // [FugitiveGasType.C3F8]: { label: 'C3F8', description: 'PFC-11' },
    [enums_1.FugitiveGasType.CHF3]: { label: 'CHF3', description: 'Trifluoromethane' },
};
exports.FUGITIVE_GAS_TYPE_LABELS = toStringLabels(exports.FUGITIVE_GAS_TYPE_LABEL_ENTRIES);
// ---------------------------------------------------------------------------
// Combined gas types (refrigerant + fugitive)
// ---------------------------------------------------------------------------
exports.GAS_TYPE_LABEL_ENTRIES = {
    ...exports.REFRIGERANT_TYPE_LABEL_ENTRIES,
    ...exports.FUGITIVE_GAS_TYPE_LABEL_ENTRIES,
};
exports.GAS_TYPE_LABELS = {
    ...exports.REFRIGERANT_TYPE_LABELS,
    ...exports.FUGITIVE_GAS_TYPE_LABELS,
};
// ---------------------------------------------------------------------------
// Process types
// ---------------------------------------------------------------------------
exports.PROCESS_TYPE_LABEL_ENTRIES = {
    [enums_1.ProcessType.CementProduction]: { label: 'Cement', description: 'Cement production' },
    [enums_1.ProcessType.SteelProduction]: { label: 'Steel', description: 'Steel production' },
    // [ProcessType.ChemicalSynthesis]: { label: 'Chemical', description: 'Chemical synthesis' }, // Too broad — @TODO freetext search UX
    // [ProcessType.AluminumSmelting]: { label: 'Aluminum', description: 'Aluminum smelting' },
    [enums_1.ProcessType.GlassManufacturing]: { label: 'Glass', description: 'Glass manufacturing' },
    [enums_1.ProcessType.LimeProduction]: { label: 'Lime', description: 'Lime production' },
    // [ProcessType.Other]: { label: 'Other' },
};
exports.PROCESS_TYPE_LABELS = toStringLabels(exports.PROCESS_TYPE_LABEL_ENTRIES);
// ---------------------------------------------------------------------------
// Data quality
// ---------------------------------------------------------------------------
exports.DATA_QUALITY_LABELS = {
    [enums_1.DataQuality.Measured]: 'Measured',
    [enums_1.DataQuality.Calculated]: 'Calculated',
    [enums_1.DataQuality.CalculatedFallback]: 'Calculated (Fallback)',
    [enums_1.DataQuality.Estimated]: 'Estimated',
    [enums_1.DataQuality.Failed]: 'Failed',
};
// ---------------------------------------------------------------------------
// Asset types
// ---------------------------------------------------------------------------
exports.ASSET_TYPE_LABEL_ENTRIES = {
    [enums_1.AssetType.Facility]: { label: 'Facility', description: 'Office, warehouse, retail, or residential property' },
    [enums_1.AssetType.Vehicle]: { label: 'Vehicle', description: 'Car, van, truck, or other motorised vehicle' },
    [enums_1.AssetType.ManufacturingFacility]: { label: 'Manufacturing Facility', description: 'Factory, plant, or production facility' },
    [enums_1.AssetType.DataCentre]: { label: 'Data Centre', description: 'Server facility or co-location' },
    [enums_1.AssetType.Equipment]: { label: 'Equipment', description: 'Standalone machinery or industrial equipment' },
    [enums_1.AssetType.Other]: { label: 'Other', description: 'Custom asset type' },
};
exports.ASSET_TYPE_LABELS = toStringLabels(exports.ASSET_TYPE_LABEL_ENTRIES);
